import React, { useCallback, useEffect, useState } from "react";
import StockAvailabilityBranch from "./StockAvailabilityBranch";
import Spinner from "../Spinner/Spinner";
import BranchSelector from "../BranchSelector/BranchSelector";

const StockAvailabilityPopup = ({
  stockBranchesList,
  stockBranchesError,
  productName,
  loading,
  onTriggered,
  branchName,
  showBranchSelector,
  children,
}) => {
  const [showPopup, setShowPopup] = useState(false);

  const handleShowPopup = useCallback(() => {
    onTriggered();
    setShowPopup(true);
  }, []);

  const handleClosePopup = useCallback(() => {
    setShowPopup(false);
  }, []);

  useEffect(() => {
    if (showPopup) {
      document.body.classList.add("overlay-active", "top-cover");
    } else {
      document.body.classList.remove("overlay-active", "top-cover");
    }

    return () => {
      document.body.classList.remove("overlay-active", "top-cover");
    };
  }, [showPopup]);

  return (
    <React.Fragment>
      {showBranchSelector && <BranchSelector branchName={branchName} onClick={handleShowPopup} />}
      {showPopup && (
        <div className="popup-stock-check__wrapper js-popup-stock-check__wrapper">
          <div className="popup-stock-check__content-wrapper">
            <a
              className="popup-stock-check-close pdp-js-close-pop-up-store"
              onClick={handleClosePopup}
            />
            <header className="popup-stock-check__content-header">
              <h5>Check stock availability for:</h5>
              <h3>{productName}</h3>
              {children}
            </header>
            <section className="popup-stock-check__content-list">
              <div className="store-finder-stock-check-list store-finder__result-list-wrapper">
                {loading && <Spinner size="30px" />}
                {(stockBranchesError ||
                  (!loading &&
                    !stockBranchesError &&
                    stockBranchesList &&
                    Object.values(stockBranchesList).length === 0)) && (
                  <div className="error-msg">
                    No branches found for your input. Please search again
                  </div>
                )}
                {!loading &&
                  !stockBranchesError &&
                  stockBranchesList &&
                  Object.values(stockBranchesList).length > 0 && (
                    <ul className="store-finder__result-list">
                      {Object.values(stockBranchesList).map((item, key) => (
                        <StockAvailabilityBranch
                          key={key}
                          branch={item.branch}
                          status={item.stockAvailability}
                        />
                      ))}
                    </ul>
                  )}
              </div>
            </section>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default StockAvailabilityPopup;
